export default {
    isDarkMode: false,
    colorScheme: {},
    themeOptions: [],
    activeTheme: null,
    initializedTheme: false,
    isEnableDynamicTheme: false,
}